import {
  PREVIEW_MINI_PLAYER_EDGE_GAP,
  type PreviewMiniPlayerFrame,
  type PreviewMiniPlayerObstacles,
} from "../preview/previewMiniPlayerLayout";
import type { PreviewMiniPlayerSize } from "~/previewMiniPlayerStore";

/** The floating window's title bar, which the figure's aspect ratio excludes. */
export const FLOATING_FIGURE_HEADER_HEIGHT = 32;
/** A figure floats at this width unless the column is narrower. */
export const FLOATING_FIGURE_DEFAULT_WIDTH = 440;
// The mini player layout never grows a window past its source's own size (a
// webview would only upscale). A figure redraws at any size, so the source
// handed to it is the figure's shape at a size no column reaches.
const SOURCE_SCALE_WIDTH = 4096;

/**
 * The size the shared layout fits the window to: the figure's own aspect
 * ratio plus the title bar, scaled past any real column so the window can
 * grow as large as the column allows.
 */
export function floatingFigureFrameSource(figure: PreviewMiniPlayerSize): PreviewMiniPlayerSize {
  const width = Math.max(1, figure.width);
  const height = Math.max(1, figure.height) + FLOATING_FIGURE_HEADER_HEIGHT;
  const scale = SOURCE_SCALE_WIDTH / width;
  return { width: SOURCE_SCALE_WIDTH, height: Math.round(height * scale) };
}

/** A maximised window covers the column above the composer, inside the edge gap. */
export function resolveMaximizedFigureFrame(
  container: PreviewMiniPlayerSize,
  obstacles: PreviewMiniPlayerObstacles,
): PreviewMiniPlayerFrame {
  const gap = PREVIEW_MINI_PLAYER_EDGE_GAP;
  const composerHeight = Math.max(0, obstacles.composer?.height ?? 0);
  return {
    x: gap,
    y: gap,
    width: Math.max(1, container.width - gap * 2),
    height: Math.max(1, container.height - composerHeight - gap * 2),
  };
}
